// extracted by mini-css-extract-plugin
export default {"headerStyle":"TranslationsPage_headerStyle__NoxmL","contentBlock":"TranslationsPage_contentBlock__n6gqe","middleBlock":"TranslationsPage_middleBlock__C5m6a"};